import './Led.css';
import React from "react";
import Led0 from '../../assets/Industries/Led/Led0.png';
import Led1 from '../../assets/Industries/Led/Led1.png';
import Led2 from '../../assets/Industries/Led/Led2.png';
import Led3 from '../../assets/Industries/Led/Led3.png';
import Led4 from '../../assets/Industries/Led/Led4.png';

const images = [
    { src: Led1, text: "COB encapsulant" },
    { src: Led2, text: "Electronic glue" },
    { src: Led3, text: "Thermal grease" },
    { src: Led4, text: "Electronic potting glue" },
];

function Led() {
    return (
        <div className="arquitectura-container">
            <div className="arquitectura-header">
                <div className="arquitectura-texto">
                    <h2>Electrónica</h2>
                    <div className="underline"></div>
                    <p>
                        Estamos comprometidos a brindar a los clientes las soluciones adhesivas electrónicas más satisfactorias, hemos estado practicando servicios personalizados, lo que debemos hacer es comprender sus necesidades, comprender sus requisitos de rendimiento para los selladores, lo que podemos hacer es brindarle una unión de sellado satisfactoria.
                    </p>
                </div>
                <div className="arquitectura-imagen">
                    <img src={Led0} alt="Arquitectura" />
                </div>
            </div>

            <div className="arquitectura-grid">
                {images.map((item, index) => (
                    <div key={index} className="arquitectura-item">
                        <img src={item.src} alt={`Arquitectura ${index + 1}`} />
                        <p>{item.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Led;
